import React from "react";
import { Modal, Button, Box, Typography } from "@mui/material";

const FailureModal = ({ open, onClose, failures }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignContent: "center",
          textAlign: "center",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          overflowY: "auto",
        }}
      >
        <Typography
          variant="h6"
          component="h1"
          gutterBottom
          color="grey"
          textTransform={"uppercase"}
        >
          File Upload Failures
        </Typography>

        {failures && failures.length > 0 ? (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ borderBottom: "1px solid #ddd", padding: "8px" }}>
                  Row
                </th>
                <th style={{ borderBottom: "1px solid #ddd", padding: "8px" }}>
                  SKU
                </th>
                <th style={{ borderBottom: "1px solid #ddd", padding: "8px" }}>
                  Error
                </th>
              </tr>
            </thead>
            <tbody>
              {failures.map((failure, index) => (
                <tr key={index}>
                  <td style={{ padding: "8px", textAlign: "center" }}>
                    {failure.row}
                  </td>
                  <td style={{ padding: "8px", textAlign: "center" }}>
                    {failure.sku}
                  </td>
                  <td style={{ padding: "8px", textAlign: "center" }}>
                    {failure.error}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No failures to display.
          </Typography>
        )}
        <Box textAlign="right" mt={2}>
          <Button onClick={onClose} variant="contained" color="primary">
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default FailureModal;
